import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlmMateriasCardComponent } from './glm-materias-card.component';
import { MateriaCardComponent } from './materia-card/materia-card.component';
import { RouterModule } from '@angular/router';
import { CustomPipesModule } from 'src/app/_pipes/custom-pipes.module';
import { GLMMaterialDesignModule } from '../material-design/material-design.module';
import { GLMAppPipesModule } from 'src/app/_modules/_pipes/app-glm-pipes.module';



@NgModule({
  declarations: [GlmMateriasCardComponent, MateriaCardComponent],
  imports: [
    CommonModule,
    RouterModule,
    CustomPipesModule,
    GLMMaterialDesignModule,
    GLMAppPipesModule.forRoot(),
  ],
  exports: [
    GlmMateriasCardComponent
  ]
})
export class GlmMateriasCardModule { }
